/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreditWalletSpendInProgressResponse,
  WalletSpendInProgressResponse,
  WalletSpendResponse,
} from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class WalletSpendController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * @description Use /in-progress/debit instead.
   *
   * @tags wallet-spend-controller
   * @name GetDebitSpendInProgressDeprecated
   * @summary This endpoint is deprecated
   * @request GET:/api/v1/wallets/{walletId}/spend/in-progress
   * @deprecated
   */
  getDebitSpendInProgressDeprecated = (walletId: string, params: RequestParams = {}) =>
    this.http.request<WalletSpendInProgressResponse, any>({
      path: `/v1/wallets/${walletId}/spend/in-progress`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDebitSpendInProgressDeprecatedPath = '/v1/wallets/${walletId}/spend/in-progress'
  static getDebitSpendInProgressDeprecatedMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-spend-controller
   * @name GetDebitSpendInProgress
   * @request GET:/api/v1/wallets/{walletId}/spend/in-progress/debit
   */
  getDebitSpendInProgress = (walletId: string, params: RequestParams = {}) =>
    this.http.request<WalletSpendInProgressResponse, any>({
      path: `/v1/wallets/${walletId}/spend/in-progress/debit`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDebitSpendInProgressPath = '/v1/wallets/${walletId}/spend/in-progress/debit'
  static getDebitSpendInProgressMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-spend-controller
   * @name GetSpendInProgressDebit2Fa
   * @request GET:/api/v1/wallets/{walletId}/spend/in-progress/debit/2fa
   */
  getSpendInProgressDebit2Fa = (walletId: string, params: RequestParams = {}) =>
    this.http.request<WalletSpendInProgressResponse, any>({
      path: `/v1/wallets/${walletId}/spend/in-progress/debit/2fa`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSpendInProgressDebit2FaPath = '/v1/wallets/${walletId}/spend/in-progress/debit/2fa'
  static getSpendInProgressDebit2FaMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-spend-controller
   * @name GetCreditSpendInProgress
   * @request GET:/api/v1/wallets/{walletId}/spend/in-progress/credit
   */
  getCreditSpendInProgress = (walletId: string, params: RequestParams = {}) =>
    this.http.request<CreditWalletSpendInProgressResponse, any>({
      path: `/v1/wallets/${walletId}/spend/in-progress/credit`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCreditSpendInProgressPath = '/v1/wallets/${walletId}/spend/in-progress/credit'
  static getCreditSpendInProgressMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-spend-controller
   * @name GetSpendInProgressCredit2Fa
   * @request GET:/api/v1/wallets/{walletId}/spend/in-progress/credit/2fa
   */
  getSpendInProgressCredit2Fa = (walletId: string, params: RequestParams = {}) =>
    this.http.request<CreditWalletSpendInProgressResponse, any>({
      path: `/v1/wallets/${walletId}/spend/in-progress/credit/2fa`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSpendInProgressCredit2FaPath = '/v1/wallets/${walletId}/spend/in-progress/credit/2fa'
  static getSpendInProgressCredit2FaMethod = 'GET'
  /**
   * @description Use /in-progress/debit/2fa instead.
   *
   * @tags wallet-spend-controller
   * @name GetSpendInProgress2Fa
   * @summary This endpoint is deprecated
   * @request GET:/api/v1/wallets/{walletId}/spend/in-progress/2fa
   * @deprecated
   */
  getSpendInProgress2Fa = (walletId: string, params: RequestParams = {}) =>
    this.http.request<WalletSpendInProgressResponse, any>({
      path: `/v1/wallets/${walletId}/spend/in-progress/2fa`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSpendInProgress2FaPath = '/v1/wallets/${walletId}/spend/in-progress/2fa'
  static getSpendInProgress2FaMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-spend-controller
   * @name GetCurrentPeriodSpend
   * @request GET:/api/v1/wallets/{walletId}/spend/current-period
   */
  getCurrentPeriodSpend = (walletId: string, params: RequestParams = {}) =>
    this.http.request<WalletSpendResponse, any>({
      path: `/v1/wallets/${walletId}/spend/current-period`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCurrentPeriodSpendPath = '/v1/wallets/${walletId}/spend/current-period'
  static getCurrentPeriodSpendMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-spend-controller
   * @name GetCurrentPeriodSpend2Fa
   * @request GET:/api/v1/wallets/{walletId}/spend/current-period/2fa
   */
  getCurrentPeriodSpend2Fa = (walletId: string, params: RequestParams = {}) =>
    this.http.request<WalletSpendResponse, any>({
      path: `/v1/wallets/${walletId}/spend/current-period/2fa`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCurrentPeriodSpend2FaPath = '/v1/wallets/${walletId}/spend/current-period/2fa'
  static getCurrentPeriodSpend2FaMethod = 'GET'
}
